var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 30,
    height: 30,
    className: "instrumentLogo",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.24,9.13H3.76c-.33,0-.62-.21-.72-.53-.1-.31,.02-.66,.29-.84L11.58,2.13c.25-.17,.59-.17,.85,0l8.24,5.62c.27,.19,.39,.53,.29,.84-.1,.31-.39,.53-.72,.53Zm-14.05-1.5h11.62l-5.81-3.97-5.81,3.97Z",
    className: "b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.48,18.2l-.02-7.63h.67c.46,0,.83,.37,.83,.83l.02,7.63h-.67c-.46,0-.83-.37-.83-.83Z",
    className: "b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8,19.03l.02-7.63c0-.46-.37-.83-.83-.83h-.67l-.02,7.63c0,.46,.37,.83,.83,.83h.67Z",
    className: "b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15,19.03l-.02-7.63c0-.46,.37-.83,.83-.83h.67l.02,7.63c0,.46-.37,.83-.83,.83h-.67Z",
    className: "b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98,19.03l-.02-7.63c0-.46,.37-.83,.83-.83h.67l.02,7.63c0,.46-.37,.83-.83,.83h-.67Z",
    className: "b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17,22H3v-.67c0-.46,.37-.83,.83-.83H21v.67c0,.46-.37,.83-.83,.83Z",
    className: "b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.56d374d669e5062544348c3dca8a67e5.svg";
export { ForwardRef as ReactComponent };